// Text parser utilities for PDF generation and text processing
export const parseTextForPDF = (input: string = ""): string => {
  if (!input) return "";
  
  let text = input.trim();
  
  // Keep LaTeX expressions intact for PDF rendering
  // Don't modify $...$ or $$...$$ expressions as they will be processed by the PDF generator
  
  // Remove image placeholders and replace with [Image]
  text = text.replace(/:::::(.*?)(?:::([\d.]+)::([\d.]+))?:::::/g, '[Image]');
  
  // Clean up extra whitespace but preserve LaTeX delimiters
  text = text.replace(/\s+/g, ' ').trim();
  
  return text;
};

// Extract plain text without LaTeX for fallback scenarios
export const extractPlainText = (input: string = ""): string => {
  if (!input) return "";
  
  let text = input.trim();
  
  // Replace LaTeX expressions with readable text
  text = text.replace(/\$\$([^$]+)\$\$/g, (match, formula) => {
    return `[${formula.trim()}]`;
  });
  
  text = text.replace(/\$([^$]+)\$/g, (match, formula) => {
    return `[${formula.trim()}]`;
  });
  
  // Remove image placeholders
  text = text.replace(/:::::(.*?)(?:::([\d.]+)::([\d.]+))?:::::/g, '[Image]');
  
  // Clean up extra whitespace
  text = text.replace(/\s+/g, ' ').trim();
  
  return text;
};